// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"PV","product":"QV","products":"RV","tooltipWrapper":"SV","tooltip":"TV","title":"UV"};